<template>
  <div>
    <VGridDropDown @change="(item)=>  this.selectedGrid = item" />
    <div class="flex items-end p-2">
      <VInput name="Name" v-model="name" mode="dark" class="flex-grow" />
      <VButton label="Save" @click="save()"></VButton>
    </div>
    <div v-for="(grid, i) of grids" :key="i">
      <div class="flex border">
        <div class="w-full p-2">
          <label class="text-white">Col Gap</label>
          <vue-slider v-model="grid.colGap" @change="update()"></vue-slider>
        </div>
        <div class="w-full p-2">
          <label class="text-white">Row Gap</label>
          <vue-slider v-model="grid.rowGap" @change="update()"></vue-slider>
        </div>
      </div>
      <div class="bg-white text-xs p-2 border">
        <div @click="selectTool({tool:'grid',value:grid})" class="border p-2">{{grid.name}}</div>
        <div v-if="getSelectedGridItem(grid)" class="flex flex-wrap">
          <div class="w-1/2 p-2" v-if="selectedGridItem">
            <label class="text-xs">COL START {{grid.cols}}</label>
            <vue-slider
              v-model="selectedGridItem.colStart"
              @change="update()"
              v-bind="{max:grid.cols+1}"
            ></vue-slider>
          </div>
          <div class="w-1/2 p-2">
            <label class="text-xs">COL END</label>
            <vue-slider
              v-model="selectedGridItem.colEnd"
              @change="update()"
              v-bind="{max:grid.cols+1}"
            ></vue-slider>
          </div>
          <div class="w-1/2 p-2">
            <label class="text-xs">ROW START {{grid.rows}}</label>
            <vue-slider
              v-model="selectedGridItem.rowStart"
              @change="update()"
              v-bind="{max:grid.rows+1}"
            ></vue-slider>
          </div>
          <div class="w-1/2 p-2">
            <label class="text-xs">ROW END</label>
            <vue-slider
              v-model="selectedGridItem.rowEnd"
              @change="update()"
              v-bind="{max:grid.rows+1}"
            ></vue-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Grid, GridItem } from "./../../store/models";

export default {
  name: "VGridPanel",
  props: {},
  data() {
    return {
      selectedGrid: { rows: 2, cols: 2 },
      selectedGridItem: new GridItem(),
      name: ""
    };
  },
  computed: {
    ...mapGetters(["selectedNodes"]),
    ...mapState(["grids"])
  },
  methods: {
    ...mapActions(["selectTool"]),
    save() {
      new Grid({ ...this.selectedGrid, rowGap: 8, colGap: 8 })
        .create()
        .then(resp => {
          console.log(resp);
        });

      // const found = this.grids.find(item => item.name == grid.name);
      // if (found) {
      //   found.set(grid);
      // } else {
      //   this.grids.push(grid);
      // }
      // const gridcss = document.querySelector("#gridcss");
      // const style = gridcss ? gridcss : document.createElement("style");
      // style.setAttribute("id", "gridcss");
      // style.setAttribute("type", "text/css");
      // style.innerText = this.grids.map(item => item.style).join("");
      // document.querySelector("head").appendChild(style);
    },
    update() {
      console.log(this.grids[0]);
      const gridcss = document.querySelector("#gridcss");
      gridcss.innerText = this.grids.map(item => item.style).join("");
      //   document.querySelector("head").appendChild(style);
    },
    getSelectedGridItem(grid) {
      if (this.selectedNodes && this.selectedNodes.length) {
        const node = this.selectedNodes[0];
        const name = node.getAttribute("name");
        const found = grid.find(name);
        if (found) this.selectedGridItem = found;
        return this.selectedGridItem;
      }
    }
  }
};
</script>

<style>
</style>